export const fetchWithDelay = url => {
    const promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(
          fetch(url, {
            method: "GET"
          }).then(response => response.json())
        );
      }, 1000);
    });
  
    return promise;
  };
  